import React from 'react';
import classnames from 'classnames';
import Tooltip from 'components/common/tool-tip-component';
import { ReactComponent as CloseButton } from 'icons/close-button.svg';
import { ReactComponent as StatementNavIcon } from 'icons/statement-navigator.svg';
import { LEFT_STATEMENT_PANEL } from 'pages/side-by-side-compare/left-side/_left-side-statement-view';

const CLOSE_ICON_DIMENSION = '28px';
export const SIDE_BY_SIDE_VIEW_STATEMENT_NAV_ICON_SIZE = '28px';

const StatementSubHeader = ({
  isSwapped,
  isSelected,
  headerTitle,
  onNavIconClick,
  onClose,
  children,
}) => {
  return (
    <div
      className={classnames(`${LEFT_STATEMENT_PANEL}__statement-header-wrap`)}
    >
      {children ? (
        children
      ) : (
        <>
          <div
            className={classnames(`${LEFT_STATEMENT_PANEL}__statement-header`, {
              [`${LEFT_STATEMENT_PANEL}__statement-header__swap`]: isSwapped,
            })}
          >
            <Tooltip
              id={`${LEFT_STATEMENT_PANEL}__statement-nav-tooltip`}
              text="toolkit.icon.statement-nav.tooltip"
              position={'right'}
            >
              <button
                id={`${LEFT_STATEMENT_PANEL}__statement-nav-button-id`}
                className={classnames(
                  `${LEFT_STATEMENT_PANEL}__statement-nav-button`,
                  {
                    [`${LEFT_STATEMENT_PANEL}__statement-header__swap__statement-nav-button`]:
                      isSwapped,
                    [`${LEFT_STATEMENT_PANEL}__statement-nav-button--selected`]:
                      isSelected,
                  },
                )}
                onClick={onNavIconClick}
              >
                <StatementNavIcon
                  className={classnames(`${LEFT_STATEMENT_PANEL}__nav-icon`)}
                  width={SIDE_BY_SIDE_VIEW_STATEMENT_NAV_ICON_SIZE}
                  height={SIDE_BY_SIDE_VIEW_STATEMENT_NAV_ICON_SIZE}
                />
              </button>
            </Tooltip>

            <span
              className={`${LEFT_STATEMENT_PANEL}__statement-header__title`}
            >
              {headerTitle}
            </span>
          </div>
          <div
            className={classnames(`${LEFT_STATEMENT_PANEL}__cancelIcon`, {
              [`${LEFT_STATEMENT_PANEL}__swap__cancelIcon`]: isSwapped,
            })}
          >
            <CloseButton
              className={`${LEFT_STATEMENT_PANEL}__cancelBtn`}
              onClick={onClose}
              height={CLOSE_ICON_DIMENSION}
              width={CLOSE_ICON_DIMENSION}
              role="button"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default StatementSubHeader;
